// // Mock authentication system for the AI education platform

// // Mock users for demonstration
export const mockUsers = [
    {
        id: "68d448d7835f201274cda482",
        name: "Jennifer Di Marco",
        email: "dimarco_jennifer.itismarconi@eduprompt.it",
        role: "teacher",
        avatar: "/teacher-avatar.png",
    },
    {
        id: "68d448d7835f201274cda483",
        name: "Mario Rossi",
        email: "rossi_mario.itismarconi@eduprompt.it",
        role: "student",
        avatar: "/student-avatar.png",
    },
    {
        id: "68d448d7835f201274cda495",
        name: "Maria Rodriguez",
        email: "maria.rodriguez@admin.edu",
        role: "administrative",
        avatar: "/admin-avatar.png",
    },
    {
        id: "68d448d7835f201274cda534",
        name: "Gulia Rossi",
        email: "gulia.rossi@admin.edu",
        role: "root",
        avatar: "/admin-avatar.png",
    },
]

export const mockStudents = [
    {
        id: "68d448d7835f201274cda483",
        name: "Mario Rossi",
        email: "rossi_mario.itismarconi@eduprompt.it",
        role: "student",
        avatar: "/images/student-avatar.png",
        isFlagged: false
    },
    {
        id: "68d448d7835f201274cda484",
        name: "Luca Ronchi",
        email: "ronchi_luca.itismarconi@eduprompt.it",
        role: "student",
        avatar: "/images/student-avatar.png",
        isFlagged: true,
        flaggedQuestion: "Why do teachers even care about this topic?",
    }, {
        id: "68d448d7835f201274cda485",
        name: "Giovanni Bianchi",
        email: "bianchi_giovanni.itismarconi@eduprompt.it",
        role: "student",
        avatar: "/images/student-avatar.png",
        isFlagged: false,
    },
]

// // Mock authentication functions
// export const signIn = async (email, password) => {
//     // Simulate API call delay
//     await new Promise((resolve) => setTimeout(resolve, 1000))

//     const user = mockUsers.find((u) => u.email === email)
//     return user || null
// }

// export const signOut = async () => {
//     await new Promise((resolve) => setTimeout(resolve, 500))
// }

// export const getCurrentUser = () => {
    
//     return {
//         "_id": "68d448d7835f201274cda482",
//         "auth0_id": "auth0|68d26b8fab4d4ab3652f7603",
//         "email": "rossi_mario.itismarconi@eduprompt.it",
//         "name": "Mario Rossi",
//         "role": "root",
//         "metadata": [],
//         "created_at": "2025-09-24T19:39:03.690000Z",
//         "updated_at": "2025-09-24T19:39:03.690000Z",
//         "school_id": "6915f82557b7d9f51ffbc384"
//     }
// }

// export const setCurrentUser = (user) => {
//     if (typeof window !== "undefined") {
//         if (user) {
//             localStorage.setItem("currentUser", JSON.stringify(user))
//         } else {
//             localStorage.removeItem("currentUser")
//         }
//     }
// }
